`<template>
  <div>
    <vs-popup class="sales-quote-email-log-popup"
              id="popup"
              :title='`OTHER ORDER PDF EMAIL LOG`'
              :active.sync="open"
              :buttons-hidden="true">
          <vs-table class="my-8" hoverFlat id="quote_item_table" :data="emailLogList" stripe>
            <template slot="thead">
              <vs-th>DATE/TIME</vs-th>
              <vs-th>STAFF USER (SENT BY)</vs-th>
              <vs-th>SUPPLIER USER (SENT TO)</vs-th>
              <vs-th>SUPPLIER USER EMAIL</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr"
                    v-for="(tr_item, indextr) in data">
              <vs-td :data="data[indextr].created_at">
                {{ __dateTimeFormatter(data[indextr].created_at) }}
              </vs-td>
              <vs-td>
                {{ data[indextr].created_by_staff_name }}
              </vs-td>
              <vs-td>
                {{ data[indextr].supplier_user_name }}
              </vs-td>
              <vs-td>
                {{ data[indextr].supplier_user_email }}
              </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>

  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import ErrorMessages from "@/mixins/ErrorMessages";
const OtherSupplierRepository = RepositoryFactory.get('other_supplier')

export default {
  name: "OtherServiceOrderInvoiceEmailLogPopUp",
  data() {
    return {
      order_id: null,
      open: false,
      emailLogList: []
    }
  },
  mixins: [ErrorMessages],
  methods:{
    async openPopUp(id){
      this.order_id = id
      await this.fetchEmailLog()
      this.open = true
    },
    async fetchEmailLog(){
      this.$vs.loading()
      try {
        const {data} = await OtherSupplierRepository.getOtherOrderInvoiceEmailLog(this.order_id)
        this.emailLogList = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    }
  }
}
</script>

<style scoped>

.sales-quote-email-log-popup >>> .vs-popup {
  min-width: 50% !important;
}
.label {

}

</style>
